import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_LALRParser = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="LALR Parser"
    videos={[
      "https://www.youtube.com/embed/ElFowfEFqXM",
      "https://www.youtube.com/embed/XEd4YdlBibM",
    ]}
    takeaways={[]}
    questions={[
      `1) Show that the following grammar is LALR (1) but not SLR(1). Justify your answer with an explanation: 
S->Aa | bAc | dc | bda 
A->d`,

      `2) Show that the following grammar is LR(1) but not LALR(1). Justify your answer with an explanation. 
S->Aa | bAc | Bc | bBa 
A->d 
B->d`,

      `3) The grammar is given for parsing simple method calls and variable assignments in Java. Check whether the given grammar is LALR(1) grammar or not. By using the above grammar parse the following method called SetBestCollege(VIT), and show the stack implementation.

Program -> Statement; 
Statement -> MethodCall | assignment 
MethodCall -> identifier ( Argument ) 
Argument -> identifier | ε 
assignment -> identifier = identifier`,

      `4) Check whether the following grammar is LALR(1) or not and give suitable justification.

S'->S 
S->aBc | bCc | aCd | bBd 
B->e 
C->e`,

      `5) Show that this context-free grammar is not LALR but CLR.

S->Aa | bAc | Bc | bBa 
A->d 
B->d`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_LALRParser;
